import React, {useContext} from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import {RouterContext} from "./Onboarding"

export default function SkipButton(props) {
  const route = useContext(RouterContext)
  let onboardingProgress = route.onboardingProgress
  const remainingPages = onboardingProgress.map((page) => page.completed).filter((completed) => completed === false).length



  return (
    <>
    {
      remainingPages !== 1 ?
      <Link to={props.nextPage}>
        <Button
          onClick={() => route.set((prev) => [...prev, window.location.pathname])}
          style={{
            backgroundColor: "#888888",
            paddingLeft: "60px",
            paddingRight: "60px",
          }}
          className="py-1 f16 skip-button nunito-regular"
          size="md"
          >
          {props.btnText}
        </Button>
      </Link>
      :
      <OverlayTrigger
        trigger={["hover", "focus"]}
        key={"top"}
        placement={"top"}
        overlay={
          <Popover id={`popover-positioned-top`}>
            <p className="text-center">You cannot skip the last page</p>
          </Popover>
        }>
        <Button
        style={{
          backgroundColor: "#70768F",
          paddingLeft: "60px",
          paddingRight: "60px",
          cursor: "default"
        }}
        className="py-1 f16 skip-button nunito-regular"
        size="md"
        >
        {props.btnText}
      </Button>    
      </OverlayTrigger>
   }
    </>
  );
}










